import SoopUiDatePicker from '@/components/ui/soop-ui-date-picker/SoopUiDatePicker';

const FILTER_TYPES = {
  DIRECT_INPUT: 'period_select',
};

/**
 * FilterOption 컴포넌트
 * @param {Object} option - 필터 옵션 정보 (type, label 포함)
 * @param {number} optionIndex - 옵션의 인덱스
 * @param {Object} filterGroup - 필터 그룹 정보 (key 포함)
 * @param {React.RefObject} calenderRef - 달력 ref
 * @param {Object} dateRange - 선택된 날짜 범위 {startDate: string, endDate: string}
 * @param {Function} getOptionClass - 옵션의 클래스명을 반환하는 함수 (option) => string
 * @param {Function} handleDirectInput - 직접입력 클릭 핸들러
 * @param {Function} handleOptionSelect - 옵션 선택 핸들러
 * @param {Function} handleDateSelected - 날짜 선택 핸들러
 */
const FilterOption = ({
  option,
  optionIndex,
  filterGroup,
  calenderRef,
  dateRange,
  getOptionClass,
  handleDirectInput,
  handleOptionSelect,
  handleDateSelected,
}) => {
  const isDirectInput = option.type === FILTER_TYPES.DIRECT_INPUT;
  const className = `${isDirectInput ? 'direct ' : ''}${getOptionClass(option)}`;

  return (
    <li className={className}>
      <button
        type='button'
        onClick={() => {
          const handler = isDirectInput
            ? handleDirectInput
            : handleOptionSelect;
          handler(filterGroup.key, optionIndex, option);
        }}>
        {option.label}
      </button>
      {isDirectInput && (
        <SoopUiDatePicker
          ref={calenderRef}
          startDate={dateRange.startDate}
          endDate={dateRange.endDate}
          handleDateSelected={({startDate, endDate}) => {
            handleDateSelected({
              filterGroupKey: filterGroup.key,
              optionIndex,
              option,
              startDate,
              endDate,
            });
          }}
        />
      )}
    </li>
  );
};

export default FilterOption;
